import * as React from "react";
import {
  ArrayField,
  DateField,
  ReferenceField,
  Show,
  SingleFieldList,
  Tab,
  TabbedShowLayout,
  TextField,
  FunctionField,
  usePermissions,
  useShowController,
  useRedirect,
  useRecordContext,
  useNotify,
  Button,
  Confirm,
  TopToolbar,
} from "react-admin";
import { ScoreShow } from "../scores/score-show";
import { isInternalAdmin } from "../../auth-provider";
import SimpleChipField from "../common/utils";
import { useEffect, useState } from "react";
import ApiClient from "../../ApiClient";
import API from "../../Routes";
import { isSuperAdmin } from "../../auth-provider";
import { Delete } from "@mui/icons-material";
import PracticeAssessmentsPanel from "./PracticeAssessmentsPanel";
import CandidateAssessmentsPanel from "./CandidateAssessmentsPanel";

const GDPRErasureButton = () => {
  const [open, setOpen] = useState(false);
  const record = useRecordContext();
  const redirect = useRedirect();
  const notify = useNotify();

  return (
    <>
      <Button label="GDPR DELETION" onClick={() => setOpen(true)} color="error">
        <Delete />
      </Button>
      <Confirm
        isOpen={open}
        title={"Delete candidate data"}
        content={`Are you sure you want to permanently erase GDPR data for candidate ${record?.id}?`}
        onConfirm={async () => {
          setOpen(false);
          try {
            await ApiClient.fetch(API.CANDIDATES.GDPR_ERASURE(record?.id), {
              method: "POST",
            });
            notify(`Candidate ${record?.id} GDPR data has been deleted successfully`);
            redirect("list", "candidates");
          } catch (error) {
            notify(
              `Failed to trigger GDPR deletion for candidate ${record?.id}: ${
                error?.message || error
              }`,
              { type: "error" }
            );
          }
        }}
        onClose={() => setOpen(false)}
      />
    </>
  );
};

const CandidateShowActions = (props) => {
  return (
    <TopToolbar {...props}>
      <GDPRErasureButton />
    </TopToolbar>
  );
};

export const CandidateShow = ({ ...props }) => {
  const [candidateUrl, setCandidateUrl] = useState({ url: String });
  const permissions = usePermissions();
  const { record } = useShowController();

  useEffect(() => {
    let didCancel = false;
    if (record) {
      (async () => {
        const urlResponse = await ApiClient.fetch(
          API.CANDIDATES.GET_URL(record.id)
        );

        if (!didCancel) {
          if (urlResponse.status === 200) {
            setCandidateUrl(urlResponse.json.url);
          }
        }
      })();
    }

    return () => {
      didCancel = true;
    };
  }, [record]);

  return (
    <Show
      {...props}
      actions={
        isSuperAdmin(permissions.permissions) ? <CandidateShowActions /> : null
      }
    >
      <TabbedShowLayout>
        <Tab label="Summary">
          <TextField source="id" />
          <TextField source="externalCorrelationId" />
          <TextField source="email" />
          <TextField source="name" />
          <TextField source="lastName" />
          <ReferenceField source="campaignId" reference="campaigns" link="show">
            <TextField source="name" />
          </ReferenceField>
          <ReferenceField
            source="createdBy"
            reference="users"
            link={isInternalAdmin(permissions.permissions) ? "show" : false}
          >
            <TextField source="firstName" />
          </ReferenceField>
          <TextField source="profileId" />
          <ArrayField source="tags">
            <SingleFieldList linkType={false}>
              <SimpleChipField />
            </SingleFieldList>
          </ArrayField>
          <DateField source="startDateTime" />
          <DateField source="endDateTime" />
          <FunctionField
            label="Url"
            source="id"
            render={(record) =>
              record?.id && (
                <a
                  href={candidateUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  View Candidate
                </a>
              )
            }
          />
        </Tab>
        <Tab label="Assessments">
          <CandidateAssessmentsPanel />
        </Tab>
        <Tab label="Scores">
          <ReferenceField
            source="candidateResultsId"
            reference="scores"
            link={false}
            label={false}
          >
            <ScoreShow />
          </ReferenceField>
        </Tab>
        <Tab label="Practice Assessments">
          <PracticeAssessmentsPanel />
        </Tab>
      </TabbedShowLayout>
    </Show>
  );
};
